import Vue from 'vue'
import Router from 'vue-router'
import Table from '@/components/Table'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Table',
      component: Table
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js